<template>
  <modal
    name="update-permit-modal"
    :classes="'customModal'"
    :scrollable="true"
    :reset="true"
    :adaptive="false"
    :width="650"
    height="auto"
    @before-open="getData"
    @closed="closeModal()"
  >
    <div class="modalWrapper">
        <div class="content__box">
            <div class="content__box__header">
                <p class="text-white txt--ss opacity--50">Update Permit</p>
            </div>
            <div class="content__divider"></div>
            <div class="content__box__body">
                <div class="row">
                    <div class="col-md-12">
                        <div class="form__group mb-3">
                            <label class="txt--xs txt--off-white">Name</label
                            ><input
                                type="text"
                                placeholder="Enter permit name"
                                class="textInputField"
                                maxlength="50"
                                v-model.trim="permit.permit_name"
                            />
                        </div>
                        <div class="form__group mb-3">
                            <label class="txt--xs txt--off-white"
                            >Permit price</label
                            >
                            <div class="input-group-prfix">
                            <span class="input-group-prefix-text">$</span>
                            <input
                                type="text"
                                @keypress="checkFloat()"
                                placeholder="Enter permit price"
                                class="textInputField"
                                v-model.number="permit.permit_price"
                            />
                            </div>
                        </div>
                        <div class="form__group mb-3">
                            <label class="txt--xs txt--off-white">Number Of Permits Available</label
                            ><input
                            type="text"
                            placeholder="Enter the number of permits available"
                            class="textInputField"
                            v-model.number="permit.permit_quantity"
                            @keypress="checkNumber"
                            />
                        </div>
                        <div class="form-group">
                            <label class="txt--xs txt--off-white mb-2 mr-2">Payments</label>
                                <ul class="top__filter__ul top__filter__ul--btn">
                                    <li
                                        class="active"
                                        v-if="permit.recurring == 0"
                                    >
                                        One-Time Payment
                                    </li>
                                    <li
                                        class="active"
                                        v-if="permit.recurring == 1"
                                    >
                                        Recurring Payments
                                    </li>
                            </ul>
                        </div>
                        <div class="form-group">
                            <app-toggle
                            :checked="fullAccess"
                            :label="'Full access'"
                            @update:checked="getCheckedStatus($event, 'fullAccess')"
                            ></app-toggle>
                        </div>                        
                    </div>
                </div>       
            </div>
        </div>
        <div class="d-flex justify-content-center flex-wrap mt-4">
            <button
            type="button"
            class="button button--primary button--sm mr-3"
            @click="updatePermit()"
            >
            Update</button
            ><button
            type="button"
            class="button button--outline button--sm"
            @click="closeModal()"
            >
            Cancel
            </button>
        </div>
        <div class="session__modal__close" @click="closeModal()">
            <i class="fas fa-times"></i>
        </div>
    </div>
  </modal>
</template>
<script>
import Toggle from "@/components/toggle";
export default {
    components:{
        AppToggle: Toggle,
    },
    data() {
        return{
            permit: {},
            fullAccess: false,
        }
    },
    methods: {
        getData(e) {
            // console.log(e.params);
            this.permit = e.params.permit;
            this.fullAccess=e.params.permit.full_access;
            //   console.log(e.params.permit.full_access)
        },
        checkNumber(evt) {
            evt = evt ? evt : window.event;
            var charCode = evt.which ? evt.which : evt.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                evt.preventDefault();
            }
            return true;
        },
        checkFloat(evt) {
            evt = evt ? evt : window.event;
            var charCode = evt.which ? evt.which : evt.keyCode;
            if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57)) {
                evt.preventDefault();
            }
            return true;
        },
        updatePermit() {
            if(this.permit.permit_name.length == 0) {
                this.$toasted.show("Permit Name is required!",{
                    icon: 'times-circle',
                    className: 'error-class'
                });
                return;
            }
            if(this.permit.permit_name.length > 40) {
                this.$toasted.show("Permit Name can not be more than 40 characters long!",{
                    icon: 'times-circle',
                    className: 'error-class'
                });
                return;
            }
            if(!window.regularExpressions.specialName.test(this.permit.permit_name)) {
                this.$toasted.show("Please provide a valid permit name!",{
                icon: 'times-circle',
                className: 'error-class'
                });
                return;
            }
            if(this.permit.permit_quantity <= 0 || this.permit.permit_quantity == '') {
                this.$toasted.show("Please provide a valid number of available permits!",{
                    icon: 'times-circle',
                    className: 'error-class'
                });
                return;
            }
            if(this.permit.permit_price == 0 && this.permit.handle_method == 'stripe') {
                this.$toasted.show("Permit price can not be 0 if handled by stripe!",{
                    icon: 'times-circle',
                    className: 'error-class'
                });
                return;
            }

            let update_request = {
                permit_name: this.permit.permit_name,
                permit_quantity: this.permit.permit_quantity,
                permit_id: this.permit.permit_id,
                permit_price: this.permit.permit_price,
                full_access: this.fullAccess ? 1 : 0,
            };

            this.axios
            .post(window.hostname + "api/auth/permit/update", update_request)
            .then(res=> {
                if(res.data.status) {
                    this.$emit("update_list");
                    this.$toasted.show(res.data.message,{
                        icon: 'check-circle',
                        className: 'success-class'
                    });
                    this.closeModal();
                }
                else {
                    this.$toasted.show(res.data.message,{
                        icon: 'times-circle',
                        className: 'error-class'
                    });
                }
            })
            .catch(err=>{ 
                this.$toasted.show(err.response.data.message,{
                    icon: 'times-circle',
                    className: 'error-class'
                });
            })
        },
        closeModal() {
            this.permit = {};
            this.$modal.hide("update-permit-modal");
        },
        getCheckedStatus(checked, type) {
             if (type == "fullAccess") {
                this.fullAccess = checked;
            }
        },
    }
}
</script>